import { Prisma } from '@prisma/client';
import { Decimal } from '@snap-types/types/decimal';
import { z } from 'zod/v4';

export const decimal = z
  .union([z.instanceof(Prisma.Decimal), z.instanceof(Decimal)])
  // @NOTE(shawk): this is important to make testing easier
  .transform((value) => new Decimal(value));

export const decimalLike = z.union([
  z.instanceof(Prisma.Decimal),
  z.instanceof(Decimal),
  z.string().refine((value) => value.length > 0),
  z.number(),
]);

export const decimalLikeToDecimal = decimalLike.transform(
  (value) => new Decimal(value),
);

export const decimalToNumber = decimal.transform((value) => value.toNumber());
